import {
  contest_banner,
  htt1,
  htt2,
  htt3,
  htt4,
  htt_banner,
  telegram_banner,
} from "../../utils/images";
import { globalConst } from "../../utils/globalConstant";

export const howtoTrade = [
  {
    title: "How it works?",
    imgUrl: htt1,
    block1:
        "Choose an outcome",
    block2:
        "Choose an event that interests you the\nmost. After selecting an event, choose 'Yes'\nif you think it will happen, and 'No' if not.",
  },
  {
    title: "How it works?",
    imgUrl: htt2,
    block1:
        "Select Price & Shares to\nplace order",
    block2:
        "Tap 'price' to edit the price, 'shares' to edit\nquantity. Your investment = Price x Number\nof Shares. Tap 'buy' to place order.",
  },
  {
    title: "How it works?",
    imgUrl: htt3,
    block1:
        "Visit portfolio to book profits",
    block2:
        "You can sell shares gradually for partial\nprofits or hold them until the event ends for\nmaximum profit",
  },
  {
    title: "How it works?",
    imgUrl: htt4,
    block1:
        "Earn 100/- for each correct share",
    block2:
        "Receive 100 for each correct share you\nown at the time of event settlement.",
  },
];

export const dummyBanners = [
  // {
  //   id: 1,
  //   image_url: telegram_banner(),
  //   link: "https://t.me/OXprediction",
  //   action: "external",
  //   isLocal: true,
  // },
  // {
  //   id: 2,
  //   image_url: htt_banner(),
  //   link: "https://www.tradexapp.co",
  //   action: "htt",
  //   isLocal: true,
  // },
];

export const contestDummyBanners = [
  {
    id: 1,
    image_url: contest_banner(),
    link: "zLWXiIHta2Y?si=e83gTkD9zpj4Xs-L",
    linkWeb: "https://youtube.com/shorts/zLWXiIHta2Y?si=e83gTkD9zpj4Xs-L",
    action: "htt",
    isLocal: true,
  },
];

export const SUPPORTLIST = [
  {
    title: "Help Center",
    link: "https://thepostcard.club/blog/3510373602878821390",
  },
  {
    title: "Raise a request",
    link: "https://support.tradexapp.co/portal/en/newticket",
  },
  {
    title: "Join TG Community",
    link: "https://t.me/OXprediction",
  },
];

export const PRODUCTLIST = [
  {
    title: "How It Works",
    link: "https://www.youtube.com/shorts/luzJel0OxE8",
  },
  {
    title: "TradeX API",
    link: "https://business.tradexapp.co/tradexapi",
  },
];

export const DOCUMENTSLIST = [
  {
    title: "Privacy Policy",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514679779502593646",
  },
  {
    title: "Terms and Conditions",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514679113765885547",
  },
  {
    title: "Cancellation and Refund Policy",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514680254465578609",
  },
  {
    title: "Account Reactivation",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514684299385247360",
  },
  {
    title: "Report Fraud",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514684753242494598",
  },
  {
    title: "Grievance Retrieval",
    link: "https://thepostcard.club/blog/3510373602878821390/article/3514684508546799235",
  },
];
